<script>
	export let background = 'bg-neutral-100'
	export let padding = 'py-5 xl:py-8'
</script>

<section class="{background} {padding}">
	<section class="page-wrapper flex flex-col-reverse xl:flex-row xl:gap-16">
		<div class="w-full xl:w-1/2">
			<slot />
		</div>
		{#if $$slots.trail}
			<div class="w-full xl:w-1/2">
				<slot name="trail" />
			</div>
		{/if}
	</section>
</section>
